"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createProfileLogic = void 0;
var CustomError_1 = require("../logic/CustomError");
var debug = __importStar(require("../util/debug"));
var ns_1 = require("../util/ns");
var utils_1 = require("../util/utils");
function createProfileLogic(store, authn, utilityLogic) {
    var ns = ns_1.ns;
    /**
     * loads the preference without throwing errors - if it can create it it does so.
     * remark: it still throws error if it cannot load profile.
     * @param user
     * @returns undefined if preferenceFile cannot be returned or NamedNode if it can find it or create it
     */
    function silencedLoadPreferences(user) {
        return __awaiter(this, void 0, void 0, function () {
            var err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, loadPreferences(user)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        err_1 = _a.sent();
                        return [2 /*return*/, undefined];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    /**
     * loads the preference without returning different errors if it cannot create or load it.
     * remark: it also throws error if it cannot load profile.
     * @param user
     * @returns undefined if preferenceFile cannot be an Error or NamedNode if it can find it or create it
     */
    function loadPreferences(user) {
        return __awaiter(this, void 0, void 0, function () {
            var possiblePreferencesFile, preferencesFile, err_2, message, response, err_3, msg;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, loadProfile(user)];
                    case 1:
                        _a.sent();
                        possiblePreferencesFile = (0, utils_1.suggestPreferencesFile)(user);
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, utilityLogic.followOrCreateLink(user, ns.space('preferencesFile'), possiblePreferencesFile, user.doc())];
                    case 3:
                        preferencesFile = _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        err_2 = _a.sent();
                        message = "User ".concat(user, " has no pointer in profile to preferences file.");
                        debug.warn(message);
                        // we are listing the possible errors
                        if (err_2 instanceof CustomError_1.NotEditableError) {
                            throw err_2;
                        }
                        if (err_2 instanceof CustomError_1.WebOperationError) {
                            throw err_2;
                        }
                        if (err_2 instanceof CustomError_1.UnauthorizedError) {
                            throw err_2;
                        }
                        if (err_2 instanceof CustomError_1.CrossOriginForbiddenError) {
                            throw err_2;
                        }
                        if (err_2 instanceof CustomError_1.SameOriginForbiddenError) {
                            throw err_2;
                        }
                        if (err_2 instanceof CustomError_1.FetchError) {
                            throw err_2;
                        }
                        throw err_2;
                    case 5:
                        _a.trys.push([5, 7, , 8]);
                        return [4 /*yield*/, store.fetcher.load(preferencesFile)];
                    case 6:
                        response = _a.sent();
                        return [3 /*break*/, 8];
                    case 7:
                        err_3 = _a.sent();
                        msg = "Unable to load preference of user ".concat(user, ": ").concat(err_3);
                        debug.warn(msg);
                        if (err_3.response.status === 401) {
                            throw new CustomError_1.UnauthorizedError();
                        }
                        if (err_3.response.status === 403) {
                            if ((0, utils_1.differentOrigin)(preferencesFile)) {
                                throw new CustomError_1.CrossOriginForbiddenError();
                            }
                            throw new CustomError_1.SameOriginForbiddenError();
                        }
                        /*if (err.response.status === 404) {
                            throw new NotFoundError();
                        }*/
                        throw new Error(msg);
                    case 8: return [2 /*return*/, preferencesFile];
                }
            });
        });
    }
    function loadProfile(user) {
        return __awaiter(this, void 0, void 0, function () {
            var err_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!user) {
                            throw new Error("loadProfile: no user given.");
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, store.fetcher.load(user.doc())];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_4 = _a.sent();
                        throw new Error("Unable to load profile of user ".concat(user, ": ").concat(err_4));
                    case 4: return [2 /*return*/, user.doc()];
                }
            });
        });
    }
    function loadMe() {
        return __awaiter(this, void 0, void 0, function () {
            var me;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        me = authn.currentUser();
                        if (me === null) {
                            throw new Error("Current user not found! Not logged in?");
                        }
                        return [4 /*yield*/, store.fetcher.load(me.doc())];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, me];
                }
            });
        });
    }
    function getPodRoot(user) {
        var podRoot = findStorage(user);
        if (!podRoot) {
            throw new Error("User pod root not found!");
        }
        return podRoot;
    }
    function getMainInbox(user) {
        return __awaiter(this, void 0, void 0, function () {
            var mainInbox;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, store.fetcher.load(user)];
                    case 1:
                        _a.sent();
                        mainInbox = store.any(user, ns.ldp("inbox"), undefined, user.doc());
                        if (!mainInbox) {
                            throw new Error("User main inbox not found!");
                        }
                        return [2 /*return*/, mainInbox];
                }
            });
        });
    }
    function findStorage(me) {
        return store.any(me, ns.space("storage"), undefined, me.doc());
    }
    return {
        loadMe: loadMe,
        getPodRoot: getPodRoot,
        getMainInbox: getMainInbox,
        findStorage: findStorage,
        loadPreferences: loadPreferences,
        loadProfile: loadProfile,
        silencedLoadPreferences: silencedLoadPreferences
    };
}
exports.createProfileLogic = createProfileLogic;
//# sourceMappingURL=profileLogic.js.map